import React from 'react';
import EntityManagementPage, { EntityField } from './EntityManagementPage';
import { useAppSelector } from '../../store/hooks';
import {
  createInventoryItem,
  deleteInventoryItem,
  fetchInventory,
  updateInventoryItem,
} from '../../store/slices/inventorySlice';
import { InventoryItem } from '../../types';

const fields: EntityField[] = [
  { key: 'name', label: 'Назва', required: true },
  { key: 'categoryId', label: 'ID категорії', type: 'number' },
  { key: 'description', label: 'Опис', type: 'textarea' },
];

const InventoryPage: React.FC = () => {
  const state = useAppSelector((s) => s.inventory);
  return (
    <EntityManagementPage<InventoryItem>
      title="Управління інвентарем"
      items={state.items}
      loading={state.loading}
      submitting={false}
      error={null}
      fields={fields}
      fetchAll={fetchInventory}
      createItem={createInventoryItem}
      updateItem={updateInventoryItem}
      deleteItem={deleteInventoryItem}
    />
  );
};

export default InventoryPage;
